import CTA from "@/components/common/CTA";
import Srcset from "@/components/common/Srcset";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import React, { useState, useRef, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";

const StoryCard = (props) => {
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1024px)");
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [storyCardImage, setImageSrc] = useState(props.storyCardImage);
  const dispatch = useDispatch();
  useEffect(() => {
    if (isMobile) {
      setImageSrc(
        props.storyCardImageMobile
          ? props.storyCardImageMobile
          : props.storyCardImage
      );
    } else if (isTablet) {
      setImageSrc(
        props.storyCardImageTablet
          ? props.storyCardImageTablet
          : props.storyCardImage
      );
    } else {
      setImageSrc(props.storyCardImage);
    }
  });

  const handleClick = (e) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }
  }

  const cardLink=props.CTAUrl;

  return (
    <>
      <a tabIndex={0} {...cardLink?{href:cardLink}:{}} onClick={(e) => handleClick(e)}>
      <div className="contentrow-carousel">
        <div className="contentrow-img-div">
           <Srcset height="100%" width="100%" src={storyCardImage} alt={props.storyAltText ? props.storyAltText : (props.heading ? props.heading : 'story card image')}/>
        </div>
        <div className="contentrow-txt-container text-center">
          <p className="contentrow-card-heading x-large-md small-sm small-xs italic">
            {props.heading}
          </p>
          {props.body && (
            <div
              className="contentrow-body small-md x-small-sm x-small-xs"
              dangerouslySetInnerHTML={{ __html: props.body }}
            ></div>
          )}
          {props.CTAText && (
            <div className="story-cta-div">
              <CTA text={props.CTAText} link={props.CTAUrl} sizeClass='large-md x-small-sm x-small-xs bordered'/>
            </div>
          )}
        </div>
      </div>
      </a>
    </>
  );
};
export default StoryCard;
